import React from 'react';
import { useFormContext } from '../../../../context/form';
import { getCreativityOptions } from '../../../../constants/clients/registry';
import { useClientId } from '../../../use-client-id';

export const useFormConfig = (fields: any[], fieldWidth: number) => {
  const { creativityType } = useFormContext();

  const clientId = useClientId();
  const creativityOptions = getCreativityOptions(clientId);
  const template = creativityOptions.find(t => t.id === creativityType);

  const accordionConfig = template?.config?.accordionConfig;

  // Crear mapa de campos para acceso rápido
  const fieldMap = React.useMemo(() => {
    const map: Record<string, any> = {};
    fields.forEach(field => {
      map[field.key] = field;
    });
    return map;
  }, [fields]);

  return {
    creativityType,
    fieldMap,
    accordionConfig
  };
};
